import PropTypes from "prop-types";
import { Box, Button, Dialog, DialogContent, DialogTitle, FormGroup, Grid, Paper, TextField, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";

import React, { useContext, useState } from 'react'; 
import themeMaker, {bssMakeStyles}  from '../../lib/theming';
import __t from '../../lib/traduzioni';
import { LocalShippingSharp } from '@mui/icons-material';
import BSSDataContext from "../../contexts/BSSDataContext";
import useBSSLogger from '../../hooks/useBSSLogger';
import { wpCurl } from "../../api/wpcurl";
import BSSDialog from "../form/BSSDialog";

const {logger} = useBSSLogger();

const defaultDialogCfg = {url: null, mostra: false};

const Tracker = ({corriere}) => {

    const [dialogTracking, setDialogTracking] = useState(defaultDialogCfg)


    const corrieri = useContext(BSSDataContext);

    logger.debug("corrieri", corrieri, corriere); 

    const [numerotracking, setNumerotracking] = useState("")
    const classes = bssMakeStyles();

    const daticorriere = corriere && (corrieri[corriere] ?? null);

    const vaiAPaginaCorriere = async (daticorriere, numerotracking) => {
        window.open(
            daticorriere.url.replace("%s", numerotracking),
            '_blank' 
        );

        // const url = daticorriere.url.replace("%s", numerotracking)
        // const data = await wpCurl(url);

        // logger.debug("ottenuta response curl", data)

        // setDialogTracking({
        //     mostra: true,
        //     url,
        //     srcdoc: data
        // })
    }


    return (

        <Paper elevation={3} className={`${classes.rounded10} ${classes.container}`}>
            <Grid  >
                <Grid item className={classes.formGroupBox}>
                    {daticorriere === null ? (
                        <span>{__t("corrierenongestito")}</span>
                    ): (
                        <>
                            <table className="nobordertable">
                                <tbody>
                                    <tr>
                                        {daticorriere?.logo && (       
                                            <td style={{width: "80px"}} rowSpan="2">
                                                <img src={daticorriere.logo} />
                                            </td>
                                        )}
                                        <td>
                                            <Typography variant="h5">
                                                {__t("cercaspedizione")}<br />
                                            </Typography>
                                        </td>
                                    </tr>       
                                    {daticorriere && (                                     
                                        <tr>
                                            <td>
                                                
                                                    <Typography variant="subtitle1" color="textSecondary">
                                                        
                                                        {__t("pressocorriere")} {daticorriere.nome}
                                                    </Typography>
                                                    
                                            
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                
                            </table>
                            

                            <Box my="0.5em">
                                <FormGroup row>

                                    <Box width={1} 
                                        mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} 
                                        >
                                        <TextField
                                            variant="outlined" 
                                            size="small"                          
                                            fullWidth 
                                            label={`${__t("numerospedizione")}`}
                                            required
                                            value={numerotracking}
                                            onInput={e => setNumerotracking(e.target.value)}
                                                />
                                    
                                    </Box>
                                    <Box width={1} pt="0.5em">
                                        <Button disabled={["", null, undefined].includes(numerotracking)} 
                                            variant="contained" 
                                            color="primary" 
                                            fullWidth
                                            onClick={e => vaiAPaginaCorriere(daticorriere, numerotracking)}    
                                        ><LocalShippingSharp /> {__t("tracciaspedizione")}</Button>
                                    </Box>
                                    
                                </FormGroup>
                            </Box>
                        </>
                    )}
                </Grid>
            </Grid>

            <BSSDialog open={dialogTracking.mostra} onClose={e => setDialogTracking(defaultDialogCfg)} fullWidth maxWidth="lg" >
                <DialogTitle>
                    <Box display="flex">
                        <Box flexGrow={1}>

                        </Box>
                        <Box>
                            <Button onClick={e => setDialogTracking(defaultDialogCfg)}>{__t("chiudi")}</Button>                            
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <iframe 
                        style={{width: "100%"}} 
                        frameBorder="no" 
                        srcDoc={dialogTracking.srcdoc}
                        src={dialogTracking.url} />
                </DialogContent>
            </BSSDialog>
        </Paper>
    )     
    
}

Tracker.propTypes = {
    corriere: PropTypes.string
}

export default Tracker;